<div class="help-container">
  <div class="drone-flying">
    <img class="icon" src="../assets/svg/icons8-drone_flight_1.svg" />
  </div>
  <div class="text-container" *ngIf="user$ | async; let user">
    <h2>Hello {{ user.firstName }},</h2>
    <p>you have to be patient, we are still working on this area.</p>
  </div>
</div>
